
import {
Component,
Vue,
Inject,
Prop,
Watch
} from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';

@Component({})
export default class videoModal extends AbpBase {
    @Prop({
        type:Boolean,default:false
    }) value
    scrollable:boolean=true
    changeStaus(){
        // this.$emit("input",false)
    };
    cancle(){
this.$emit("input",false)
    }
}
